import { useHttp } from "../http/useHttp";
import { useAxiosQuery, UseAxiosQueryOptions } from "../http/useAxiosQuery";
import { useMemo } from "react";
import { useAuth } from "../auth/useAuth";
import { paths } from "../generated-types";

type BluePenguinUsersOperation = paths["/dashboard/synota/blue-penguin/users"]["post"];
export type UseBluePenguinUsersInput = BluePenguinUsersOperation["parameters"]["query"];
export type UseBluePenguinUsersResponse =
  BluePenguinUsersOperation["responses"][200]["content"]["application/json"];
export type IBluePenguinUser = UseBluePenguinUsersResponse[number];

export const useBluePenguinUsers = (
  input: UseBluePenguinUsersInput = {},
  options: Omit<UseAxiosQueryOptions<UseBluePenguinUsersResponse>, "queryKey" | "queryFn"> = {},
) => {
  const { client } = useHttp();
  const { isAdmin } = useAuth();

  const { status, isPending, isFetching, isLoading, data, error, refetch } =
    useAxiosQuery<UseBluePenguinUsersResponse>({
      queryKey: ["blue-penguin-list-users", input],
      queryFn: ({ signal }) =>
        client.post("/synota/blue-penguin/users", undefined, { signal, params: input }),
      ...options,
      enabled: Boolean(isAdmin && options.enabled !== false),
    });

  const bpUsers = useMemo(() => {
    if (!data) {
      return [];
    }
    return data.data;
  }, [data]);

  return {
    bpUsers,
    error,
    isLoading,
    isFetching,
    isPending,
    status,
    refetch,
  };
};

export type UseBluePenguinUsersReturn = ReturnType<typeof useBluePenguinUsers>;
